export const PRESENTATION_FIT_DESIGN_WIDTH = 1000;
export const PRESENTATION_FIT_DESIGN_WIDTH_LIVE = 740;
export const PRESENTATION_FIT_MIN_SCALE = 0.38;
export const PRESENTATION_FIT_MAX_SCALE = 2.85;

export function fitPresentationScale(input: {
  readonly availableWidth: number;
  readonly availableHeight: number;
  readonly contentWidth: number;
  readonly contentHeight: number;
  readonly minScale?: number;
  readonly maxScale?: number;
}): number {
  const {
    availableWidth,
    availableHeight,
    contentWidth,
    contentHeight,
    minScale = PRESENTATION_FIT_MIN_SCALE,
    maxScale = PRESENTATION_FIT_MAX_SCALE,
  } = input;
  if (availableWidth <= 0 || availableHeight <= 0 || contentWidth <= 0 || contentHeight <= 0) {
    return 1;
  }
  const raw = Math.min(availableWidth / contentWidth, availableHeight / contentHeight);
  const clamped = Math.min(maxScale, Math.max(minScale, raw));
  return Math.round(clamped * 1000) / 1000;
}
